import { TextField, Box, Typography, ButtonBase, InputAdornment } from '@mui/material';
import FieldWrapper from '../FieldWrapper';

export default function Step10Reddito({ data, onChange, errors }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
          Situazione economica
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 0.5 }}>
          Inserisci i dati sul tuo reddito
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <FieldWrapper label="Tipo Reddito" required error={errors?.tipo_reddito} completed={!!data.tipo_reddito}>
          <Box sx={{ display: 'flex', gap: 1 }}>
            {['Netto', 'Lordo'].map(opt => (
              <ButtonBase
                key={opt}
                onClick={() => onChange('tipo_reddito', opt)}
                sx={{
                  flex: 1,
                  py: 1.5,
                  px: 2,
                  borderRadius: 2,
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  border: '2px solid',
                  transition: 'all 0.2s',
                  borderColor: data.tipo_reddito === opt ? 'primary.main' : 'divider',
                  bgcolor: data.tipo_reddito === opt ? 'primary.light' : 'transparent',
                  color: data.tipo_reddito === opt ? 'primary.main' : 'text.secondary',
                  '&:hover': { borderColor: 'primary.main' }
                }}
              >
                {opt}
              </ButtonBase>
            ))}
          </Box>
        </FieldWrapper>

        <FieldWrapper label="Numero mensilità" error={errors?.numero_mensilita} completed={!!data.numero_mensilita} hint="Di solito 12, 13 o 14 mensilità">
          <TextField 
            fullWidth 
            size="small" 
            type="number" 
            inputProps={{ min: 1, max: 18 }} 
            value={data.numero_mensilita || ''} 
            onChange={e => onChange('numero_mensilita', parseInt(e.target.value) || '')} 
            placeholder="Es. 13" 
          />
        </FieldWrapper>

        <FieldWrapper label="Reddito mensile" required error={errors?.reddito} completed={!!data.reddito} hint="Importo mensile in euro">
          <TextField
            fullWidth
            size="small"
            type="number"
            value={data.reddito || ''}
            onChange={e => onChange('reddito', parseFloat(e.target.value) || '')}
            placeholder="0,00"
            InputProps={{
              startAdornment: <InputAdornment position="start">€</InputAdornment>
            }}
          />
        </FieldWrapper>
      </Box>
    </Box>
  );
}